import {
  FlexRow,
  MaterialIcon,
  StyledButton,
  StyledSearchBar,
  useDebouncedSearch,
  useModal,
} from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { useRecoilState, useResetRecoilState } from 'recoil';
import useEffectOnce from '../../../hooks/useEffectOnce';
import { useStyles } from '../../../hooks/useStyles';
import { subAccountsSearchFilterState } from '../../../storage/subAccounts';
import StyledTooltip from '../../ui/StyledTooltip';
import SubAccountDetailModal from './modal/SubAccountDetailModal';

type Props = {
  clientId?: string;
  subClientId?: string;
  onReloadPage: () => void;
};
export function SubAccountFiltersBar({ clientId, subClientId, onReloadPage }: Readonly<Props>) {
  const { css, theme } = useStyles();
  const { openModal: openFormModal, closeModal: closeFormModal, showModal: showFormModal } = useModal();
  const { search, setSearch } = useDebouncedSearch(useRecoilState(subAccountsSearchFilterState));
  const resetSearch = useResetRecoilState(subAccountsSearchFilterState);

  useEffectOnce(() => {
    return () => {
      resetSearch();
    };
  });

  return (
    <FlexRow
      classNames={css({
        justifyContent: 'space-between',
        width: '100%',
      })}
    >
      <FlexRow
        gap={theme.sizing.scale300}
        classNames={css({
          width: '70%',
        })}
      >
        <FlexRow
          classNames={css({
            width: '60%',
          })}
        >
          <StyledSearchBar
            value={search ?? ''}
            onChange={setSearch}
            clearable
            noMargin
          />
        </FlexRow>
      </FlexRow>
      <FlexRow gap={theme.sizing.scale300}>
        <StyledTooltip
          content={'Recargar tabla'}
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={onReloadPage}
            kind="tertiary"
          >
            <MaterialIcon name={'refresh'} />
          </Button>
        </StyledTooltip>
        <StyledButton
          onClick={openFormModal}
          startEnhancer={
            <MaterialIcon
              name="add"
              size="xs-mini"
              color={theme.colors.contentInversePrimary}
            />
          }
        >
          Nueva
        </StyledButton>
      </FlexRow>
      {showFormModal && (
        <SubAccountDetailModal
          clientId={clientId}
          subClientId={subClientId}
          onClose={(updateTable) => {
            if (updateTable) {
              onReloadPage();
            }
            closeFormModal();
          }}
          isOpen={showFormModal}
        />
      )}
    </FlexRow>
  );
}
